import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ProcessSection from '@/components/feature/ProcessSection';
import WhyChooseUs from '@/components/feature/WhyChooseUs';
import ServiceAreas from '@/components/feature/ServiceAreas';
import Testimonials from '@/components/feature/Testimonials';
import FAQSection from '@/components/feature/FAQSection';
import FinalCTA from '@/components/feature/FinalCTA';
import MidPageCTA from '@/components/feature/MidPageCTA';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesOverview from './components/ServicesOverview';
import AIAnswerBlock from './components/AIAnswerBlock';

const homeAIQA = [
  {
    q: 'What is TINTSPRO X?',
    a: 'TINTSPRO X is a professional window tinting company in Philadelphia, PA. They specialize in automotive, residential, and commercial window tinting — providing premium film installation for vehicles, homes, and businesses across the Philadelphia area.',
  },
  {
    q: 'What window tinting services does TINTSPRO X offer?',
    a: 'TINTSPRO X offers automotive tinting, commercial tinting, residential tinting, ceramic tinting, carbon fiber installation, and window film services — all using premium-grade materials and precision installation techniques.',
  },
  {
    q: 'What are the benefits of professional window tinting?',
    a: 'Professional window tinting reduces interior heat by up to 60%, blocks 99% of UV rays that fade upholstery and furnishings, improves privacy, reduces glare, protects skin from UV damage, and gives vehicles and buildings a clean, finished appearance.',
  },
  {
    q: 'How does the window tinting process work?',
    a: 'The process includes a free consultation, window surface cleaning and preparation, precision film cutting to exact measurements, expert film installation using professional tools, and a final quality inspection — all completed with zero shortcuts.',
  },
];

const homeFAQs = [
  {
    q: 'Who provides window tinting near me in Philadelphia?',
    a: 'TINTSPRO X provides professional window tinting for all vehicles, homes, and businesses in Philadelphia and surrounding areas. Located at 3001 Ormes St Unit 05, they use premium film brands and precision installation for flawless, lasting results.',
  },
  {
    q: 'How much does window tinting cost in Philadelphia?',
    a: 'Window tinting cost depends on vehicle type, number of windows, and the film grade chosen. Prices vary based on sedan, SUV, or truck, plus residential or commercial scope. Contact TINTSPRO X at (215) 594-9404 for a free, accurate custom quote.',
  },
  {
    q: 'How long does window tinting last?',
    a: 'Quality window tint film lasts 5–10 years depending on the film type and maintenance. Carbon and ceramic tint films last longer than standard dyed films, maintaining heat rejection and color without fading or bubbling over time.',
  },
  {
    q: 'Do you tint front windows and windshields?',
    a: 'Yes. TINTSPRO X tints all windows including front doors and applies specialized windshield strip tinting within Pennsylvania legal limits. All installations comply with PA tint regulations, and clients are advised on legal requirements before service.',
  },
];

export default function Home() {
  return (
    <div className="bg-[#080808]">
      <Navbar />
      <HeroSection
        eyebrow="Philadelphia, PA · Professional Window Tinting"
        title="Premium Window Tinting for Automotive, Residential & Commercial"
        subtitle="Professional window film installation that blocks heat, rejects UV rays, and enhances privacy — expert tinting for vehicles, homes, and businesses that demand quality."
        primaryCTA="Get a Free Quote"
        secondaryCTA="View Our Services"
        secondaryCTALink="/services"
      />
      <TrustBar />
      <ServicesOverview />
      <MidPageCTA
        heading="Ready to Upgrade Your Windows?"
        subheading="Get a free quote from Philadelphia's professional window tinting studio — automotive, residential, and commercial."
        ctaLabel="Get Free Quote"
        variant="gold"
      />
      <AIAnswerBlock heading="About TINTSPRO X" items={homeAIQA} />
      <ProcessSection />
      <WhyChooseUs />
      <MidPageCTA
        heading="Book Your Appointment — No Obligation"
        subheading="Premium window films. Expert installation. Professional finish."
        ctaLabel="Book Appointment"
        variant="dark"
      />
      <ServiceAreas />
      <Testimonials />
      <FAQSection heading="Frequently Asked Questions" items={homeFAQs} />
      <FinalCTA
        heading="Protect Your Space.&#10;Elevate Your View."
        subheading="Get a custom quote for window tinting — automotive, residential, or commercial. No obligation."
        buttonLabel="Request Your Free Quote"
      />
      <Footer />
    </div>
  );
}
